import { render, staticRenderFns } from "./roleShop.vue?vue&type=template&id=fc850b46&scoped=true"
import script from "./roleShop.vue?vue&type=script&lang=js"
export * from "./roleShop.vue?vue&type=script&lang=js"
import style0 from "./roleShop.vue?vue&type=style&index=0&id=fc850b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc850b46",
  null
  
)

export default component.exports